import { createAppRequest } from '@/services/request';

const request = createAppRequest();

export interface SceneBindingRow {
  uuid: string;
  appId: string;
  sceneCode: string;
  sceneName: string;
  ability: string;
  defaultModelRef?: string | null;
  tenantSelectable: boolean;
  tenantModelRef?: string | null;
  effectiveModelRef?: string | null;
}

export interface FlatModelItem {
  modelRef: string;
  modelName: string;
  modelType?: string;
  available?: boolean;
  official?: boolean;
  providerType?: string;
  providerName?: string;
  providerLogo?: string;
  providerOfficial?: boolean;
}

export async function hasRegisteredScenes(appId: string) {
  if (!appId.trim()) {
    return false;
  }
  try {
    const result = await request<{ appId: string; hasScenes: boolean }>(
      `/bff/ai/llm/scenes/apps/${encodeURIComponent(appId.trim())}/exists`,
      { method: 'GET', skipErrorHandler: true },
    );
    return !!result?.hasScenes;
  } catch {
    return false;
  }
}

export async function listSceneBindings(appId: string) {
  return request<SceneBindingRow[]>('/bff/ai/llm/scenes/bindings', {
    method: 'GET',
    params: { appId },
  });
}

export async function listFlatModels(appId: string) {
  return request<FlatModelItem[]>('/bff/ai/llm/api/models/flat', {
    method: 'GET',
    params: { appId, includeUnavailable: false },
  });
}

export async function upsertSceneBinding(
  appId: string,
  data: { sceneCode: string; ability: string; modelRef: string },
) {
  return request(`/bff/ai/llm/scenes/bindings/${encodeURIComponent(appId)}`, {
    method: 'PUT',
    data,
  });
}

export async function removeSceneBinding(
  appId: string,
  sceneCode: string,
  ability: string,
) {
  return request(
    `/bff/ai/llm/scenes/bindings/${encodeURIComponent(appId)}/${encodeURIComponent(sceneCode)}/${encodeURIComponent(ability)}`,
    { method: 'DELETE' },
  );
}
